var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewSet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.591,
    height: 18.764,
    viewBox: "0 0 14.591 18.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{stroke:#000;stroke-width:0.3px;}.b,.c{fill:#0a0a0a;}.b{stroke:#ebb546;stroke-linecap:round;stroke-width:0.5px;}.d{stroke:none;}.e{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1610.524 -1295.748)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1615.115 1301.639)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.441 -5.741)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.276,17.878H30.224a.91.91,0,0,1-.908-.908V1.494a.91.91,0,0,1,.908-.908h8.792A.627.627,0,0,1,39.1.592V2.419a1.5,1.5,0,0,0,1.494,1.494h1.827A.62.62,0,0,1,42.428,4V8.986a.293.293,0,0,0,.586,0V4a1.2,1.2,0,0,0-.352-.851L39.867.352A1.2,1.2,0,0,0,39.016,0H30.224A1.5,1.5,0,0,0,28.73,1.494V16.969a1.5,1.5,0,0,0,1.494,1.494h3.052a.293.293,0,1,0,0-.586Zm8.738-14.55H40.595a.91.91,0,0,1-.908-.908V1Z",
    transform: "translate(-28.73 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 7)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(1616.115 1296) rotate(90)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 11,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.25,
    y: 0.25,
    width: 10.5,
    height: 2.5,
    rx: 1.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9 1)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(1618.115 1299)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 11,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.25,
    y: 0.25,
    width: 10.5,
    height: 2.5,
    rx: 1.25
  })), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 5,
    height: 2,
    rx: 1,
    transform: "translate(1621.115 1299.5)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(1615.615 1296.5) rotate(90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSet);
export default __webpack_public_path__ + "static/media/newSet.de7027a86288e840718457c4b470152b.svg";
export { ForwardRef as ReactComponent };